import axios from 'axios'
import auth from '@/auth'

export default class APIService{
    constructor(apiName){
        this.ApiUrl = process.env.API_URL + apiName
        this.AxiosInstance = axios.create({ baseURL: process.env.API_URL })
        this.AxiosInstance.defaults.headers.common['Authorization'] = auth.getAuthHeader();
    }
}


// WEBPACK FOOTER //
// ./src/api/index.js